if (!customElements.get('redlight-product-selector')) {
  customElements.define(
    'redlight-product-selector',
    class RedlightProductSelector extends HTMLElement {
      constructor() {
        super();
        this.radioInputs = this.querySelectorAll('input[type="radio"]');
        this.productData = this.getProductData();

        this.radioInputs.forEach((input) => {
          input.addEventListener('change', this.onProductChange.bind(this));
        });
      }

      getProductData() {
        const dataScript = this.querySelector('script[data-product-info]');
        if (dataScript) {
          try {
            return JSON.parse(dataScript.textContent);
          } catch (e) {
            console.error('Error parsing product data:', e);
            return null;
          }
        }
        return null;
      }

      getCurrentVariantSelections() {
        if (!this.productData || !this.productData.currentProduct) return {};

        const currentProduct = this.productData.currentProduct;
        const selectedVariant = currentProduct.selected_or_first_available_variant;

        if (!selectedVariant) return {};

        // Get the option names from the current product
        const options = {};
        if (currentProduct.options && currentProduct.options.length > 0) {
          currentProduct.options.forEach((optionName, index) => {
            const optionKey = `option${index + 1}`;
            const value = selectedVariant[optionKey];
            if (value) {
              options[optionName] = value;
            }
          });
        }

        return options;
      }

      async fetchProductData(handle) {
        try {
          const response = await fetch(`/products/${handle}.js`);
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return await response.json();
        } catch (error) {
          console.error('Error fetching product:', error);
          return null;
        }
      }

      findMatchingVariant(targetProduct, currentSelections) {
        if (!targetProduct || !targetProduct.variants) {
          return null;
        }

        const variants = targetProduct.variants;

        // Create a mapping of target product option names to their positions
        const targetOptionMapping = {};
        if (targetProduct.options && targetProduct.options.length > 0) {
          targetProduct.options.forEach((optionName, index) => {
            targetOptionMapping[optionName] = `option${index + 1}`;
          });
        }

        // Try to find a variant that matches current selections
        let matchingVariant = variants.find((variant) => {
          if (!variant.available) return false;

          let matches = true;

          // Match each option by name
          Object.keys(currentSelections).forEach((optionName) => {
            const optionKey = targetOptionMapping[optionName];
            if (optionKey && variant[optionKey]) {
              matches = matches && variant[optionKey] === currentSelections[optionName];
            }
          });

          return matches;
        });

        if (matchingVariant) {
          return matchingVariant;
        }

        // Fall back to first available variant
        return variants.find((variant) => variant.available) || variants[0];
      }

      async onProductChange(event) {
        const selectedInput = event.target;
        const targetProductId = selectedInput.dataset.productId;
        const targetHandle = selectedInput.dataset.productHandle;

        if (!targetProductId || !targetHandle) {
          console.error('Missing product data on input');
          return;
        }

        // Don't navigate if already on this product
        if (this.productData && targetProductId === String(this.productData.currentProductId)) {
          return;
        }

        // Get current variant selections
        const currentSelections = this.getCurrentVariantSelections();

        // Fetch target product data
        const targetProduct = await this.fetchProductData(targetHandle);

        if (!targetProduct) {
          // If we can't fetch the product, just navigate to the product page
          window.location.href = `/products/${targetHandle}`;
          return;
        }

        // Find matching variant on target product
        const targetVariant = this.findMatchingVariant(targetProduct, currentSelections);

        // Build URL
        let url = `/products/${targetHandle}`;
        if (targetVariant && targetVariant.id) {
          url += `?variant=${targetVariant.id}`;
        }

        // Navigate to new product page
        window.location.href = url;
      }
    }
  );
}
